import {createElement} from 'methods/utils';
import View from './view';
import BookingModal from './modal';
import Icons from '/modules/hotels/src/js/components/order/cancellation-policy/model/icons';

class Button extends View() {
    constructor($element, options = {}) {
        super($element, { textType: 'short', ...options });

        this.icons = Icons('small');
        this.hintIcon = Icons('hint');

        this.$element.addEventListener('click', () => {
            BookingModal.getInstance(this.options?.modal)
                .revise(this.cancellationPolicy.get())
                .open();
        });

        this.revise(this.options.booking);
    }

    getElement() {
        return this.$element;
    }

    getFreeCancellationHTML(text) {
        return text ? `${this.icons.free}${text}${this.hintIcon}` : '';
    }

    getNoCancellationHTML(text) {
        return text ? `${this.icons.no}${text}${this.hintIcon}` : '';
    }

    getNoRefundCancellationHTML(text) {
        return text ? `${this.icons.noRefund}${text}${this.hintIcon}` : '';
    }

    getPenaltyCancellationHTML(text) {
        return text ? `${this.icons.penalty}${text}${this.hintIcon}` : '';
    }

    revise(data) {
        super.revise(data);

        const { free } = this.cancellationPolicy.get();

        this.$element.innerHTML = '';

        let html = this.getFreeCancellationHTML(free?.text);

        this.empty = !html;

        this.$element.insertAdjacentHTML('afterbegin', html);
    }

    static make(options) {
        const $element = createElement(`
            <button class="CancellationPolicyButton js-cancellationPolicyButton"></button>
        `);

        return new Button($element, options);
    }
}

export default Button;
